const MAX_TAX_RATE = 0.5
const MIN_TAX_RATE = 0.0001
const PRECISION = 6

export class TaxRate {
  /**
   * The tax rate as a decimal between 0 and 1.
   */
  readonly value: number
  /**
   * The tax rate as a string between 0 and 100.
   */
  readonly stringValue: string

  constructor(rate: number | string | null | undefined) {
    if (typeof rate === 'string') {
      this.value = parseFloat(rate)
      if (!isNaN(this.value)) {
        this.value /= 100
      }
    } else {
      this.value = rate ?? Number.NaN
    }

    this.stringValue = isNaN(this.value) ? '' : (this.value * 100).toFixed(PRECISION)
  }

  get valid() {
    return !Number.isNaN(this.value) && this.value >= MIN_TAX_RATE && this.value <= MAX_TAX_RATE
  }
}
